import { IconProps } from "../../utils/global-types/global-types";

const UploadLeadsIcon = ({ className, ...rest }: IconProps) => (
  <svg
    viewBox="0 0 14 14"
    className={className ? className : "w-[18px] h-[18px]"}
    {...rest}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_352_28008)">
      <path
        d="M6.75595 11.8189C5.93442 11.8189 5.1129 11.8189 4.29334 11.8189C3.16769 11.8169 2.35604 11.0092 2.35011 9.88358C2.34814 9.49059 2.34814 9.0976 2.35011 8.70461C2.35209 8.29977 2.59697 8.0391 2.97416 8.03712C3.35135 8.03515 3.5982 8.29582 3.60215 8.70066C3.60413 9.09958 3.60018 9.50047 3.60413 9.90136C3.60808 10.32 3.85296 10.5649 4.27557 10.5649H9.26596C9.68659 10.5649 9.93345 10.32 9.9374 9.90136C9.93937 9.50244 9.93542 9.10155 9.93937 8.70066C9.94135 8.29582 10.1882 8.03712 10.5654 8.03712C10.9426 8.03712 11.1914 8.2978 11.1875 8.70461C11.1835 9.21609 11.2112 9.7335 11.148 10.2371C11.0295 11.1613 10.2435 11.813 9.30743 11.8169C8.4543 11.8229 7.60513 11.8189 6.75595 11.8189Z"
        fill="currentColor"
      />
      <path
        d="M6.13945 3.8665C6.04465 3.95537 5.98739 4.00474 5.93604 4.05609C5.53515 4.46093 5.13821 4.86774 4.73534 5.26863C4.44899 5.55498 4.05205 5.57473 3.79533 5.3259C3.5386 5.07707 3.54847 4.66631 3.8289 4.38193C4.64648 3.56041 5.46603 2.74085 6.28756 1.92327C6.57786 1.63495 6.95505 1.63495 7.24337 1.92327C8.07083 2.7448 8.89433 3.56831 9.71586 4.39576C9.98641 4.66828 9.98838 5.07905 9.73561 5.32393C9.48283 5.5688 9.08391 5.55696 8.80941 5.28443C8.40062 4.87761 7.99973 4.46488 7.59489 4.05609C7.54355 4.00277 7.48628 3.9534 7.40334 3.87638C7.39741 3.98894 7.39149 4.06201 7.39149 4.13706C7.39149 5.42859 7.39346 6.7221 7.38951 8.01364C7.38754 8.49945 6.96295 8.78777 6.51861 8.61399C6.27373 8.5192 6.13945 8.30591 6.13945 7.99389C6.13747 6.71618 6.13747 5.43847 6.13945 4.15878V3.8665Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_352_28008">
        <rect
          width="10.1111"
          height="10.1111"
          fill="white"
          transform="translate(1.70996 1.71094)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default UploadLeadsIcon;
